import type {
  LoginResponse,
  TaraExchangeResult,
  TaraRegisterRequestBody,
} from '@/types/auth';
import type { CreateCustomerProfileRequestBodyDTO } from '@/types/dto/agent';
import type { LoginValues } from '@/utils/zodSchema';
import { createContext } from 'react';

export interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  logout: () => Promise<void>;
  loginWithPassword: (values: LoginValues) => Promise<LoginResponse>;
  registerWithPassword: (
    values: CreateCustomerProfileRequestBodyDTO
  ) => Promise<void>;
  registerWithTara: (values: TaraRegisterRequestBody) => Promise<void>;
  /** Verifies an unverified customer profile using the token from the confirmation email. */
  verifyRegistration: (
    unverifiedCustomerProfileId: string,
    verificationHash: string
  ) => Promise<void>;
  /** Full-page redirect to TARA to begin the eID login flow. */
  startTaraLogin: () => void;
  /**
   * Exchanges the TARA login-result token. On `authenticated` the session is
   * established here (tokens stored + profile loaded); the caller only handles
   * navigation and the `needs_registration` fork.
   */
  loginWithTara: (loginResultToken: string) => Promise<TaraExchangeResult>;
}

export const AuthContext = createContext<AuthContextType | null>(null);
